import Vue from 'vue';

const Analytics = new Vue();

export default Analytics;



// WEBPACK FOOTER //
// ./src/components/mixins/analytics.js